import { z } from 'zod'
import { oc } from '@orpc/contract'

export const chargeQuoteSchema = z.object({
  code: z.string(),
  basePrice: z.number().nullable(),
  midlevelPrice: z.number().nullable(),
  credential: z.enum(['MD', 'DO', 'NP', 'PA', 'RN']).nullable(),
  percent: z.number().nullable(),
  submittedCharge: z.number().nullable(),
  source: z.enum(['catalog-midlevel', 'catalog-base', 'none']),
  reason: z
    .enum([
      'no-catalog-price',
      'credential-not-recorded',
      'credential-cannot-bill',
      'patient-under-18',
    ])
    .optional(),
})

// Submitted charge per CPT/HCPCS code for one rendering provider and patient
// (PD-1597): the organization's catalog price (MD/DO base, optional NP/PA
// amount) tiered by the provider's recorded credential under the org's fee
// policy. Returns the inputs it used so the note can show the breakdown.
// Expected reimbursement is deliberately absent — no contract or CMS rates are
// configured; the UI prints the unavailable message.
export const billingQuoteCharge = oc
  .route({ method: 'POST', path: '/v2/billing/quote-charge' })
  .input(
    z.object({
      codes: z.array(z.string().trim().min(1)).min(1).max(20),
      practitionerId: z.string().min(1),
      patientId: z.string().min(1),
      /** Prices for this encounter's organization — the one save and Lock judge; wins over `organizationId`. */
      encounterId: z.string().min(1).optional(),
      /** Defaults to the organization the caller acts for. */
      organizationId: z.string().min(1).optional(),
    }),
  )
  .output(
    z.object({
      provider: z.object({
        id: z.string(),
        display: z.string().nullable(),
        credential: z.enum(['MD', 'DO', 'NP', 'PA', 'RN']).nullable(),
        licenseState: z.string().nullable(),
        /** PD-2017 — the provider was removed; the quote uses their last saved record. */
        removed: z.boolean().optional(),
      }),
      patientAge: z.number().nullable(),
      insuranceCategory: z.string().nullable(),
      quotes: z.array(chargeQuoteSchema),
    }),
  )
